const AccessibilitySection = () => (
  <section className="grid__container">
    <div className="grid__row content-block">
      <div className="grid__column--12">
        <h2>Accessibility</h2>
        <div>
          <p>
            Our vision? To make Skyscanner a flagship of disability inclusion,
            our products accessible to all, and travel planning easier for
            people with disabilities.
          </p>
          <p>
            Year over year, we&apos;ve improved our accessibility scores, and
            thanks to our accessibility champions, we&apos;ll continue to work
            to make Skyscanner products as accessible as possible. We&apos;re
            also taking our first steps in supporting the wider travel industry
            to do similarly.
          </p>
        </div>
      </div>
    </div>

    <div className="grid__row content-block" style={{ paddingTop: '0' }}>
      <div className="video-container--landscape">
        <video
          className="video"
          controls
          src="https://content.skyscnr.com/m/2ea6ecdcb0d64e77/original/Accessibility-Positive-Impact.mp4"
          width="100%"
          poster="https://content.skyscnr.com/m/5f47dfc4ce42073d/original/accessibility-thumnail.png?imbypass=true"
        >
          <track
            src="../../transcripts/Skyscanner-Accessibility-v3-en-GB.vtt"
            kind="captions"
            label="English"
          />
        </video>
      </div>
    </div>

    <div className="grid__row row--top-align content-block">
      <div className="grid__column--6 grid__column--tablet-12 photo-container">
        <img
          className="photo"
          alt="Skyscanner mobile app with accessiblity features higlighted"
          src="https://content.skyscnr.com/m/64084200e1d7f86e/original/accessibility-phone.png?imbypass=true"
        />
      </div>

      <div className="grid__column--6 grid__column--tablet-12">
        <p className="no-top-margin">
          Our work in building accessibility awareness and change across our
          business includes ensuring every new employee experiences an Empathy
          Lab, and building our Accessibility Champions Network, made up of
          passionate volunteers from all areas of the business. This now boasts
          around 7% of our staff.
        </p>
        <p>
          Now, designers are annotating their designs with accessibility
          information to ensure a seamless transition to engineering. Engineers
          are now running automated and manual accessibility tests before
          shipping code, and as a business we run user-testing sessions with
          disabled users to learn from their lived experiences.
        </p>
      </div>
    </div>

    <div className="grid__row row--top-align content-block">
      <div className="grid__column--6 grid__column--tablet-12 photo-container--left">
        <img
          className="photo mobile-and-tablet-only"
          alt="Skyscanner employees at one of our empathy labs"
          src="https://content.skyscnr.com/m/a0c0f80b369501b/original/accessibility-photo.png?imbypass=true"
        />
      </div>

      <div className="grid__column--6 grid__column--tablet-12">
        <p className="no-top-margin">
          Changes across our brand colour palette have made the colours and
          colour combinations more accessible, and we&apos;ve added 20 new
          accessibility amenities that disabled travellers can use when
          filtering hotels. We&apos;re also working to improve our procurement
          process to ensure we work with accessible suppliers.
        </p>
        <p>
          More widely, our people have volunteered with charitable accessibility
          organisations, Skyscanner is part of the Champions of Accessibility
          Network (CAN), and collaborates with organisations and universities in
          both guest lectures, webinars, and sponsorship of accessibility
          prizes.
        </p>
      </div>

      <div className="grid__column--6 grid__column--tablet-12 photo-container--right">
        <img
          className="photo desktop-only"
          alt="Skyscanner employees at one of our empathy labs"
          src="https://content.skyscnr.com/m/a0c0f80b369501b/original/accessibility-photo.png?imbypass=true"
        />
      </div>
    </div>

    <div className="grid__row content-block">
      <div className="video-container--landscape">
        <video
          className="video"
          controls
          src="https://content.skyscnr.com/m/f4c7d5dc069b1bf/original/Skyscanner_empathy_lab_4K_captioned_140324.mp4"
          width="100%"
          poster="https://content.skyscnr.com/m/212359580fb1cf8/original/heather-thumbnail.png?imbypass=true"
        >
          <track
            src="../../transcripts/Skyscanner_empathy_lab_captioned-en-GB.vtt"
            kind="captions"
            label="English"
          />
        </video>
      </div>
    </div>

    <div className="grid__row row--top-align content-block">
      <div className="grid__column--5 grid__column--tablet-12">
        <img
          className="photo"
          alt="Abdul, a blind traveller"
          src="https://content.skyscnr.com/m/1875412f3dc552a5/original/abdul-photo.png?imbypass=true"
        />
      </div>
      <div className="grid__column--7 grid__column--tablet-12">
        <p className="quote no-top-margin">
          “Last week, I was able to use my screen reader as a visually impaired
          person to book my first flight with Skyscanner, travelling from
          Glasgow to Birmingham for a football match. The ease with which I
          could navigate and complete the booking was truly remarkable and made
          the entire process seamless for me.”
        </p>
        <p className="sub-heading">Abdul, a blind traveller</p>
      </div>
    </div>

    <hr aria-hidden="true" />
  </section>
);

export default AccessibilitySection;
